import { CurrenciesPage } from 'features/currencies';

export const TechOperatorCurrenciesPage: React.FC = () => <CurrenciesPage />;
